import { OrderService } from "@/pages/taskpane/lib/order/service/OrderService";
import { CheckSuitableForMovingOrderEnum } from "@/pages/taskpane/lib/order/types/Enums";
import {
    IDeleteReservationTempRequest,
    IDialogMessageBase,
    ISaveMovingOrderTempRequest,
    IViewMovingOrderRequest
} from "@/pages/taskpane/lib/order/types/OrderEntity";
import {
    DialogErrorCode,
    DialogEventType,
    EOfficeDialogMessageType,
    IDialogModel,
} from "@/pages/taskpane/lib/utils/dialog";
import { usePreSelectedResourceStore } from "@/pages/taskpane/shared/stores/preSelectedResourceStore";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";
import { useMemo } from "react";

export const useMoveOrder = () => {
  const orderService = useMemo(() => new OrderService(), []);
  const { removeItem } = usePreSelectedResourceStore();

  const saveMovingOrderTemp = async (request: ISaveMovingOrderTempRequest) => {
    const response = await orderService.createMovingOrderTemp(request);
    return response;
  };

  const deleteTempReservation = async (request: IDeleteReservationTempRequest) => {
    const response = await orderService.deleteTempReservation(request);
    return response;
  };

  const onYesMoveOrder = async (
    notify: PreSelectedResourceInfo,
    requestMoveOrderTemp: ISaveMovingOrderTempRequest,
  ) => {
    switch (notify.movingOrder?.movingOrderType) {
      case CheckSuitableForMovingOrderEnum.PartialSuitable:
      case CheckSuitableForMovingOrderEnum.Deadline:
      case CheckSuitableForMovingOrderEnum.TotalSuitable:
        await saveMovingOrderTemp(requestMoveOrderTemp);
        removeItem(notify);
        break;
      case CheckSuitableForMovingOrderEnum.DeadlineStopMoving:
      case CheckSuitableForMovingOrderEnum.NotSupport:
        removeItem(notify);
        break;
      case CheckSuitableForMovingOrderEnum.Holiday:
        await deleteTempReservation({ CustomUid: requestMoveOrderTemp.Uid });
        removeItem(notify);
        break;
      default:
        break;
    }
  };

  const onNoMoveOrder = async (
    notify: PreSelectedResourceInfo,
    icalUid: string
  ) => {
    await deleteTempReservation({ CustomUid: icalUid });
    removeItem(notify);
  };

  const onViewOrder = async (
    requestViewMovingOrder: IViewMovingOrderRequest
  ) => {
    orderService.viewMovingOrder(requestViewMovingOrder, (dialog: IDialogModel) => {
      dialog.addEventHandler(
        DialogEventType.DialogEventReceived,
        (args: { message: string; origin: string | undefined } | { error: number }) => {
          if ((args as { error: number }).error === DialogErrorCode.Closed) {
            console.log("Order dialog closed");
          }
        }
      );
      dialog.addEventHandler(
        DialogEventType.DialogMessageReceived,
        (args: { message: string; origin: string | undefined } | { error: number }) => {
          //console.log(args, "Message from child");
          if ((args as { message: string }).message) {
            const message = JSON.parse((args as { message: string }).message) as IDialogMessageBase;
            switch (message.MessageType) {
              case EOfficeDialogMessageType.CloseDialog: {
                dialog.close();
                break;
              }
            }
          }
        }
      );
    });
  };

  return {
    onYesMoveOrder,
    onNoMoveOrder,
    onViewOrder,
  };
};
